import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ShowLeaveStatus from '../LeaveStatusCard/LeaveStatus';

export const buildQuotaApprovalRows = (request) => {
  const eventsByManager = {};
  (request.approvalEvents || []).forEach((event) => {
    eventsByManager[event.managerId] = event;
  });
  return (request.requiredApproverIds || []).map((approverId) => {
    const event = eventsByManager[approverId];
    return {
      approverId,
      status: event?.status || 'PENDING',
      dateOfResponse: event?.createdAt || null,
      comments: '',
    };
  });
};

const RemoteOfficeHoursQuotaApprovalStatus = ({ request }) => {
  const rows = buildQuotaApprovalRows(request);
  if (rows.length === 0) {
    return null;
  }

  return (
    <Accordion disableGutters elevation={0} sx={{ mt: 1, '&:before': { display: 'none' } }}>
      <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
        <Typography variant="body2">
          <strong>Approval Status</strong>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ width: '100%' }}>
          {rows.map((row) => (
            <ShowLeaveStatus key={row.approverId} managerResponse={row} />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default RemoteOfficeHoursQuotaApprovalStatus;
